TS.ns('WL');

WL.outOfOfficeModel = new Class({ 
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;   

        me.parent(config);

        var outOfOfficeList = me.getDomainProperty('dgOutOfOfficeCollection_Property');
        if (outOfOfficeList) {
            outOfOfficeList.on('beforeDelete', me.onOutOfOfficeDeleted);
        }

        var replacedUserListSearch = me.getDomainProperty('asReplacedUser_Property');
        if (replacedUserListSearch)
            replacedUserListSearch.on('selectionChanged', me.onUserListSearchChanged, me);

        var replacementUserListSearch = me.getDomainProperty('asReplacementUser_Property');
        if (replacementUserListSearch)
            replacementUserListSearch.on('selectionChanged', me.onUserListSearchChanged, me);
    },

    onUserListSearchChanged: function (newValue) {
        var me = this;


    },

    onOutOfOfficeDeleted: function (e) {
        var me = this,
            owner = me._getOwner();

        owner.performServerCommand({
            cmd: 'DeleteOutOfOffice',
            submitModel: true,
            extraData: {
                UID: e.item.uid
            },
            blockUI: true
        })
    }
});